import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import NextBackButton from "../../NextBackButton";

export const PrimaryBorrower = ({ formData, setForm, navigation }) => {
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const checkForNextStep = () => {
    if (
      formData.primaryBorrowerFirstName === "" &&
      formData.primaryBorrowerLastName === ""
    ) {
      setError(true);
      console.log("error");
    }
    if (
      formData.primaryBorrowerFirstName !== "" &&
      formData.primaryBorrowerLastName !== ""
    ) {
      navigation.next();
      console.log("next");
    }
  };
  return (
    <div className="flex flex-col h-screen w-full">
      <ProgressBar width={"95%"} />
      <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center">
              <h1 className="pb-10 text-4xl text-blue-primary font-semibold text-center w-full">
                Who will be the primary borrower on the loan?
              </h1>
              <div className="flex justify-evenly flex-col space-y-8 mx-auto">
                <div>
                  <div className="w-full flex justify-center items-center">
                    <input
                      name="primaryBorrowerFirstName"
                      value={formData.primaryBorrowerFirstName}
                      onChange={setForm}
                      id="primaryBorrowerFirstName"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block w-full text-xl font-semibold border-gray-300 rounded-md w-1/2 md:w-60 py-1 px-2"
                      placeholder="First Name"
                    />
                    <label className="ml-6 text-xl font-semibold text-gray-satan">First Name</label>
                  </div>
                </div>
                <div className="">
                  <div className="flex justify-center items-center">
                    <input
                      name="primaryBorrowerLastName"
                      value={formData.primaryBorrowerLastName}
                      onChange={setForm}
                      id="primaryBorrowerLastName"
                      className="shadow-sm border focus:ring-green-primary focus:border-green-primary block w-full text-xl font-semibold border-gray-300 rounded-md w-1/2 md:w-60 py-1 px-2"
                      placeholder="Last Name"
                    />
                    <label className="ml-6 text-xl font-semibold text-gray-satan">Last Name</label>
                  </div>
                </div>
                {error ? <p className="text-red-error text-center">Please fill out an answer</p> : null}
              </div>
            </animated.div>
          ) : null
        )}
      </div>
      <NextBackButton callBack={checkForNextStep} goBack={() => navigation.previous()} />
    </div>
  );
};
